import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { ServiceData } from "../Data/ServiceData";
import { BlogData } from "../Data/BlogData";
import { TeamData } from "../Data/TeamData";
import { WorkData } from "../Data/WorkData";


const HeroGlobal = ({title}) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const location = useLocation();
  const pathName = location.pathname;
  const { slug } = useParams();
  const [cardTitle, setCardTitle] = useState();
  const allDataArr = [...ServiceData, ...BlogData,...TeamData,...WorkData];
  useEffect(() => {
    const filteredData = allDataArr.filter((data) => data.slug === slug);
    setCardTitle(filteredData[0]);
  }, [slug]);
  console.log("serviceDetails", cardTitle);

  useEffect(() => {
    const pathnameParts = location.pathname.split("/").filter((p) => !!p);
    const breadcrumbs = pathnameParts.map((part, i) => ({
      title: part,
      path: `/${pathnameParts.slice(0, i + 1).join("/")}`,
    }));
    setBreadcrumbs(breadcrumbs);
  }, [location]);
  return (
    <div className=" top-0 w-full">
      <div className="bg-banner-global bg-no-repeat bg-cover w-full  relative ">
        <div className="main_container1 py-56 pb-24">
          <div className="flex flex-col gap-8 items-center justify-center">
            <h2 className="bg-troo-white text-center p-2"> {cardTitle?.name || title}</h2>
            <ul className="flex flex-wrap gap-1 justify-center">
              <Link to="/">Home</Link>
              <span>/</span>
              {breadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={index}>
                  <li
                    className={`capitalize ${
                      index === breadcrumbs.length - 1
                        ? "text-troo-primary font-bold"
                        : ""
                    }`}
                  >
                    <Link
                      to={breadcrumb.path}
                      className={`${
                        breadcrumb.path === pathName
                          ? "text-troo-primary font-bold"
                          : ""
                      } ${breadcrumb.path === "/faq" ? "uppercase" : ""}`}
                    >
                      {breadcrumb.title.replace(/-/g, " ")}
                    </Link>
                  </li>
                  {index !== breadcrumbs.length - 1 && <span>/</span>}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
};

export default HeroGlobal;
